const get = (source: any, path: string, defaultValue: any) => {
    if (!!source && !!path) {
      const parts = path.split(".");
      const length = parts.length;
      let result = source;
      for (let i = 0; i < length; i++) {
        let item = result[parts[i]];
        if (item === null || item === undefined) {
          return item || defaultValue;
        }
        result = item;
      }
      return result;
    }
    return defaultValue;
  };

  const generatePassword = (length: number) => {
    let result = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789@#$%{}[]()/\~<>'
    const charactersLength = characters.length
    for (let index = 0; index < length; index++) {
      result = result + characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  
  export { get,generatePassword };